<common-upload-image
  [id]="id"
  #upload
  (file)="uploadFile($event)"
  (uploadError)="showError($event)"
  [uploadDisabled]="uploadDisabled || isLoading()"
  (drop)="dropFile($event)"
  class="sim-place-image"
>
  @if (!uploadDisabled && !isLoading()) {
    <div class="select-image">
      <sim-icon sizeType="mega" color="white" icon="image" />
      <div i18n="@@GENERAL_DRAG_AND_DROP_IMAGE" class="center-description">Drag And Drop Image</div>
    </div>
  }
  @if (uploadDisabled || !isLoading()) {
    <img
      class="sim-place-image"
      [src]="image ? image : imageUrl || defaultImageUrl"
      [class.dark-hover]="upload.value"
      [class]="uploadDisabled ? 'clear-filter' : 'dark'"
    />
  } @else {
    <sim-spinner />
  }
</common-upload-image>
